

import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import LongList from './LongList/index';
import ShortList from './ShortList';
import Chemistry from './Chemistry';
import Confirmed from './Confirmed';
import { Button, Typography, AppBar, Toolbar } from '@material-ui/core';
import FindCoachSearcrh from './FindCoachSearcrh';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    tabRoot: {
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: "solid",
        borderColor: "#ddd",
        '& .MuiTabs-flexContainer': {
            justifyContent: "flex-start"
        },
        '& .MuiTabs-indicator': {
            backgroundColor: "transparent"
        }
    },
    tabs: {
        // color: "#1e1e1e",
        //  backgroundColor: "rgba(7,127,131,1)",
        textTransform: "none",
        "&.Mui-selected": {
            borderWidth: 0,
            borderBottomWidth: 1,
            borderStyle: "solid",
            borderColor: sessionStorage.getItem('role') === 'admin' ? 'rgb(7, 127,131)' : '#981B1E',
            zIndex: 1,
            color: sessionStorage.getItem('role') === 'admin' ? 'rgb(7, 127,131)' : '#981B1E',
        }
    },
    overviewContainer: {
        position: 'sticky', top: 64, paddingTop: 40, background: '#fff', zIndex: 2
    },
    appBar: {
        backgroundColor: "#fff",
        color: '#232323',
        boxShadow: "0px 3px 6px #232323",
        marginBottom: '2rem'
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
            {value === index && children}
        </Box>
    );
}

export default function ShortlistCoaching(props) {
    //
    const disableData = useSelector((state) => state.commonReducer)?.accessPermission?.assignmentDetail?.shortlistCoachesTab?.disableData;
    const classes = useStyles();
    const { assignmentId } = props
     const globaluserData = useSelector((state) => state.commonReducer);
     const role = globaluserData.role;
    // const role = sessionStorage.getItem('role')
    const [value, setValue] = React.useState(0);
    const [searchFlag, setSearchFlag] = React.useState(false);

    const tabArr = ["Longlist", "Shortlist", "Chemistry", "Confirmed"].filter(el=>!(role === "employee" && (el === "Longlist"||el === "Confirmed")))
    const tabPanelArr = [<LongList {...props} value={value} setValue={setValue} />, <ShortList  {...props} value={value} setValue={setValue} />, <Chemistry  {...props} value={value} setValue={setValue} />, <Confirmed  {...props} value={value} setValue={setValue} />].filter((el,id)=>!(role === "employee" && (id === 0||id === 3)))

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const toggleSearchFlag = () => {
        setSearchFlag(false)
    }


    return <>
        {!disableData ? !searchFlag ?
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={11} style={{ textAlign: "center" }} direction="row" justify="center" alignItems="center" className={classes.overviewContainer}>
                    <AppBar position="static" className={classes.appBar} elevation={0}>
                        <Toolbar>
                            <Grid container direction="row" justify="left" alignItems="left" xs={12}>
                                <Grid item xs={6} style={{ alignSelf: "center" }}>
                                    <Typography variant="h1" style={{ color: "#4A4A4A" , textTransform: "none" }}>
                                        <Box textAlign="left" fontWeight="fontWeightBold">Coach shortlist details</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} textAlign="right" >
                                   {!(role==="employee") && <Box textAlign="right" >
                                        <Button variant="contained" color="secondary" onClick={() => setSearchFlag(true)} style={{ textTransform: "none" }} >Find coach</Button>
                                    </Box>}
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                </Grid>
                <Grid item xs={11}>
                    <Box>
                        <Tabs value={value} onChange={handleChange} classes={{ root: classes.tabRoot }}>
                            {
                                tabArr.map((option) => <Tab variant="contained" color='primary' classes={{ root: classes.tabs }} label={option} />)
                            }
                        </Tabs>
                        {
                            tabPanelArr.map((option, index) => <TabPanel value={value} index={index}>{option}</TabPanel>)
                        }
                    </Box>
                </Grid>
            </Grid>
            : <FindCoachSearcrh {...props} assignmentId={assignmentId} toggleSearchFlag={toggleSearchFlag} setSearchFlag={setSearchFlag} />
            : <Grid container spacing={2} style={{

                display: "flex",
                width: "90 %",
                margin: "16px 8px",
                padding: "36px"
            }}>
                <Grid item xs={12}><Typography variant="subtitle1" style={{ fontWeight: "bold" }}>Confirmed coaches</Typography></Grid>
                <Grid item xs={12}>
                    <Confirmed  {...props} disableData={disableData} value={value} setValue={setValue} />
                </Grid>

            </Grid>
        }
    </>
}
